(() => {
  if (customElements.get("comparison-chart-scroll")) return;

  const MIN_PROGRESS = 18;

  class ComparisonChartScroll extends HTMLElement {
    constructor() {
      super();

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.scroller = this.querySelector("[data-comparison-scroller]");
      this.progress = this.querySelector("[data-comparison-progress]");
      if (!this.scroller || !this.progress) return;

      this.scroller.addEventListener("scroll", this.onScroll, { passive: true });
      this.resizeObserver = new ResizeObserver(this.onResize);
      this.resizeObserver.observe(this.scroller);
      this.onResize();
    }

    disconnectedCallback() {
      this.scroller?.removeEventListener("scroll", this.onScroll);
      this.resizeObserver?.disconnect();
    }

    get maxScroll() {
      return this.scroller.scrollWidth - this.scroller.clientWidth;
    }

    onResize() {
      this.progress.hidden = this.maxScroll <= 1;
      this.onScroll();
    }

    onScroll() {
      const ratio = this.maxScroll > 0 ? Math.min(Math.abs(this.scroller.scrollLeft) / this.maxScroll, 1) : 0;
      this.progress.value = MIN_PROGRESS + (100 - MIN_PROGRESS) * ratio;
    }
  }

  customElements.define("comparison-chart-scroll", ComparisonChartScroll);
})();
